import React from 'react';
import Productss from '../../Products';

function Products() {
    return (
        <>
            <Productss />
        </>
    );
}

export default Products;
